import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 2px;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.2;
  overflow: hidden;
  width: 2.8ch;
  text-align: right;
  background-color: #eee;
  color: #999;
  position: absolute;
  left: -2.8ch;
  top: 0;
  border: 1px solid rgb(206, 212, 218);
  border-radius: 3px 0 0 3px;
`;
